import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { ArrowDown } from '../icon/icons/ArrowDown';
import { ArrowUp } from '../icon/icons/ArrowUp';

interface SoldDataDirectionValueProps {
  value: string | number;
  direction?: string;
}

const StyledSoldDataDirectionValue = styled.span`
  ${({ theme: { space } }) => css`
    display: flex;
    align-items: center;
    gap: ${space.xs};
  `};
`;

export const SoldDataDirectionValue: FC<SoldDataDirectionValueProps> = ({ value, direction, ...rest }) => (
  <StyledSoldDataDirectionValue {...rest}>
    {value}
    {value !== 'No data' && direction ? (
      <>{direction === 'up' ? <ArrowUp color="valid" /> : <ArrowDown color="invalid" />}</>
    ) : (
      ''
    )}
  </StyledSoldDataDirectionValue>
);
